import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";

function safePathToEvent(pathname) {
  // normalize route -> event name (no slashes, no empty)
  const p = (pathname || "/").toLowerCase();
  if (p === "/") return "page_home";
  return "page_" + p.replace(/^\//, "").replace(/[^\w]+/g, "_");
}

function ClarityTracker({ location }) {
  useEffect(() => {
    if (!window.clarity) return;

    const eventName = safePathToEvent(location.pathname);

    // Track page change
    window.clarity("event", eventName);

    // Optional: tag sessions by current route (helps filtering)
    // Keep tags short & low-cardinality
    window.clarity("set", "route", location.pathname);
  }, [location.pathname]);

  return null;
}

export default withRouter(ClarityTracker);
